export const namespace = 'canalplus.block.oneshop.products.highlight';
export { default as Component } from './components/OfferHighlight';
export { default as propsFormatter } from './propsFormatter';
